import React from 'react'
import PropTypes from 'prop-types'

import { H1, Button } from '../Common'

import style from './SignupError.scss'

import disappointed from '../../images/emojis/disappointed.svg'

function SignupError({ loading, onRetry }) {
  return (
    <div className={style.wrapper}>
      <img src={disappointed} alt="Emoji Infeliz!" />
      <H1>ops!</H1>
      <p>
        Houve algum problema técnico durante o seu cadastro e não foi possível criar a sua conta. <br />
        Por favor tente novamente em alguns minutos.
      </p>
      <Button loading={loading} onClick={onRetry} xl>
        tentar novamente
      </Button>
    </div>
  )
}

SignupError.propTypes = {
  loading: PropTypes.bool,
  onRetry: PropTypes.func.isRequired,
}

export default SignupError



// WEBPACK FOOTER //
// ./src/components/Pages/SignupError.js